
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import DashboardContainer from '../../Dashboard/DashboardContainer';
import EntityContainer from '../../Entity/EntityContainer';
import LoginContainer from '../../Login/LoginContainer';
import NotFoundView from './NotFoundVIew';
import TransactionContainer from '../../Transaction/TransactionContainer';

const MemberAppView: React.FC =
  () =>
    (
      <Routes>
        <Route path='/' element={<LoginContainer />} />
        <Route path='/login/callback' element={<LoginCallback />} />
        <Route path='/branches/:branchId' element={<DashboardContainer />} />
        <Route path='/dashboard' element={<DashboardContainer />} />
        <Route path='/entity/:entityId/' element={<EntityContainer />} />
        <Route path='/add-transaction/' element={<TransactionContainer />} />
        <Route path='/transaction/:transactionId' element={<TransactionContainer />} />
        <Route path='*' element={<NotFoundView />} />
      </Routes>
    )

export default MemberAppView
